// Pool general
export const selectPoolState = state => state.pool;
export const selectPoolLoading = state => state.pool.isLoading;
export const selectPoolError = state => state.pool.error;

// Pools
export const selectAllPools = state => state.pool.pools;
export const selectPoolById = (state, poolId) => {
  const pools = state.pool.pools;
  return pools.find(pool => pool.id === poolId);
};

// Pools tenants
export const selectAllPoolTenants = state => state.pool.tenants;
